import React, {ChangeEvent} from 'react';
import {Select, SelectOption} from '@flixbus/honeycomb-react';
import {useAppDispatch} from '@/Pages/Common/hooks/useAppDispatch';
import {productionCostBaseUpdate} from '@/Pages/ProductionCost/store/slice';
import {LeasingCostCalculationType} from '@/Pages/ProductionCost/store/types';
import {useAppSelector} from '@/Pages/Common/hooks/useAppSelector';
import LabelWithTooltip from '@/components/LabelWithTooltip/LabelWithTooltip';

const LeasingCostCalculationTypeSelector: React.FC = () => {
  const dispatch = useAppDispatch();
  const id = 'leasing-cost-calculation-type';

  const leasingCostCalculationType = useAppSelector(
    ({productionCost}) => productionCost.leasingCostCalculationType
  );

  const onClickOption = (event: ChangeEvent<HTMLSelectElement>) => {
    dispatch(
      productionCostBaseUpdate({
        leasingCostCalculationType: event.target
          .value as LeasingCostCalculationType
      })
    );
  };

  return (
    <Select
      id={`${id}-selector`}
      label={
        <LabelWithTooltip
          label="Leasing/amortisation cost calculation*"
          htmlFor={`${id}-selector`}
          tooltipProps={{
            id: `${id}-tooltip`,
            position: 'top',
            content: `
                In the CPC standard approach, the leasing/amortisation costs per vehicle & schedule are based on the duration of the schedule.
                The alternative modes translate a part of the monthly fixed cost into variable cost and are thus beneficial for Flix.
                Further information is provided in the CPC user documentation.
              `
          }}
        />
      }
      value={leasingCostCalculationType}
      onChange={onClickOption}
      extraClasses="hcr-space-1-right"
    >
      <SelectOption value={LeasingCostCalculationType.Standard}>
        CPC standard (whole planning period)
      </SelectOption>
      <SelectOption value={LeasingCostCalculationType.FixedSplit30To70}>
        Split fixed cost: 30% operating days, 70% mileage
      </SelectOption>
      <SelectOption value={LeasingCostCalculationType.FixedSplit25To75}>
        Split fixed cost: 25% operating days, 75% mileage
      </SelectOption>
    </Select>
  );
};

export default React.memo(LeasingCostCalculationTypeSelector);
